import { get, post } from '@/fn/ajax'
import { clean } from '@/fn/object'

export async function getCateList() {
  const res = await get('/api/cate/alist_json')
  return res
}

export async function getGeneralCateList() {
  const res = await get('/api/cate/getGeneralCate_json')
  return res
}

export async function getSubCateList(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/cate/getSubCate_json', qdata)
  return res
}

export async function queryList(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/res/alist', qdata)
  return res
}

export async function courseItem(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/course/item_json', qdata)
  return res
}

export async function saveList(data: any) {
  const res = await post('/api/course/edit_json', data)
  return res
}

export async function sendRes(data: any) {
  const res = await post('/api/play/send_resource', data)
  return res
}

export async function getMyList() {
  const res = await get('/api/course/list_json')
  return res
}
// 后台管理
export async function getAccountList(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/account/alist', qdata)
  return res
}

export async function getContentList(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/res/kejian_list', qdata)
  return res
}

export async function getInstallList(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/install/alist', qdata)
  return res
}
export async function getInstallListByClient(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/install/alistByClient', qdata)
  return res
}
export async function getInstallResourceListByClient(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/install/resourceListByClient', qdata)
  return res
}

export async function getBindinglList(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/classes/lists', qdata)
  return res
}

export async function accountEdit(data: any) {
  const res = await post('/api/account/edit', data)
  return res
}
export async function accountDel(data: any) {
  const res = await post('/api/account/delete', data)
  return res
}
export async function contentUpdate(data: any) {
  const res = await post('/api/res/update_res', data)
  return res
}
export async function contentEdit(data: any) {
  const res = await post('/api/res/edit_res', data)
  return res
}
export async function installsSend(data: any) {
  const res = await post('/api/play/send_resource', data)
  return res
}
export async function installsDel(data: any) {
  const res = await post('/api/play/delete_resource', data)
  return res
}
export async function classEdit(data: any) {
  const res = await post('/api/classes/edit', data)
  return res
}
export async function classDel(data: any) {
  const res = await post('/api/classes/delete', data)
  return res
}
export async function classClients(query: any) {
  const qdata = clean(query, [null, undefined, '', 0])
  const res = await get('/api/classes/clients', qdata)
  return res
}
export async function studentDel(data: any) {
  const res = await post('/api/classes/unbind_client_alias', data)
  return res
}
export async function studentBind(data: any) {
  const res = await post('/api/classes/bind_client_alias', data)
  return res
}

export async function changePwd(data: any) {
  const res = await post('/api/user/edit', data)
  return res
}

